var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"link_more"},[_c('span',{staticClass:"link_more_text p"},[_vm._v(_vm._s(_vm.linkText))]),_c('NextArrow',{staticClass:"link_more_icon",attrs:{"fillColor":_vm.fillColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }